import { forwardRef, useState, useEffect } from 'react';
import Button from '@ebsco-ui/button';
import { createBemBlockBuilder } from '@ebsco-ui/utils';
import IndeterminateSpinner from '@ebsco-ui/indeterminate-spinner';
import cn from 'classnames';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var _excluded = ["isLoading", "disabled", "styleType", "type", "announceLoadingStart", "announceLoadingEnd", "loadingPlaceholder", "className", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var extendedStyleType = ["standard"];

var getStyleType = function getStyleType(styleType) {
  return extendedStyleType.includes(styleType) ? "default" : styleType;
};

var baseClassName = "eb-loading-button";
var LoadingButton = forwardRef(function (_ref, forwardedRef) {
  var _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$styleType = _ref.styleType,
      styleType = _ref$styleType === void 0 ? "default" : _ref$styleType,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "button" : _ref$type,
      announceLoadingStart = _ref.announceLoadingStart,
      announceLoadingEnd = _ref.announceLoadingEnd,
      loadingPlaceholder = _ref.loadingPlaceholder,
      className = _ref.className,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  var getBlocksWith = createBemBlockBuilder([baseClassName, className]); // This is required to prevent announcement
  // of the loading state on initial component render

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      shouldAnnounce = _useState2[0],
      setShouldAnnounce = _useState2[1];

  useEffect(function () {
    isLoading && setShouldAnnounce(true);
  }, [isLoading]);
  return /*#__PURE__*/jsxs(Fragment, {
    children: [shouldAnnounce && /*#__PURE__*/jsx("div", {
      role: "alert",
      className: "screen-reader-text",
      "aria-live": "polite",
      children: isLoading ? announceLoadingStart : announceLoadingEnd
    }), /*#__PURE__*/jsxs(Button, _objectSpread(_objectSpread({
      ref: forwardedRef,
      className: cn(getBlocksWith(), getBlocksWith("--".concat(styleType)), loadingPlaceholder && isLoading && getBlocksWith("--inline"), disabled && getBlocksWith("--disabled"), isLoading && getBlocksWith("--loading")),
      "data-auto": baseClassName,
      disabled: disabled || isLoading,
      styleType: getStyleType(styleType),
      type: type
    }, rest), {}, {
      children: [children && /*#__PURE__*/jsx("div", {
        "data-auto": "".concat(baseClassName, "-content"),
        className: cn(getBlocksWith("__content"), isLoading && getBlocksWith("__content--hidden")),
        children: children
      }), isLoading && /*#__PURE__*/jsxs("div", {
        "data-auto": "".concat(baseClassName, "-loader"),
        className: getBlocksWith("__loader"),
        children: [loadingPlaceholder, /*#__PURE__*/jsx(IndeterminateSpinner, {
          className: getBlocksWith("__spinner"),
          level: "component",
          "aria-hidden": "true"
        })]
      })]
    }))]
  });
});

export { LoadingButton as default };
//# sourceMappingURL=loading-button-esm.js.map
